import React, { Component } from 'react';

export default class AlignItemsFlexStart extends React.Component {
  render() {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="17.9961"
          height="1.38432"
          transform="matrix(1 0 0 -1 0 17.9984)"
          fill="black"
        />
        <rect
          width="2.76863"
          height="15.2275"
          transform="matrix(1 0 0 -1 4.15436 15.2275)"
          fill="black"
        />
        <rect
          width="2.76863"
          height="9.69021"
          transform="matrix(1 0 0 -1 12.459 15.2275)"
          fill="black"
        />
      </svg>
    );
  }
}
